import type { AxiosInstance } from 'axios'
import { wrapApiCall } from '@/lib/axios'
import { deserialize } from 'ts-jackson'
import { District, Location, Province, RoleGroup, SubDistrict, TrainingService } from './model'
import { Role } from '../model'
import { RoleCategoriesResponse } from './roleCategories'

export const MasterDataService = (client: AxiosInstance) => {
  return {
    async getRoleCategories(): Promise<RoleCategoriesResponse> {
      const { data } = await wrapApiCall(() =>
        client.get<RoleCategoriesResponse>('/roles/categories')
      )
      return data
    },
    async getLocation(zipCode: string): Promise<Location[]> {
      const { data } = await wrapApiCall(() =>
        client.get<Record<string, unknown>[]>('/locations', { params: { zipCode } })
      )
      return data?.map((item: Record<string, unknown>) => deserialize(item, Location)) || []
    },
    async getProvinces(): Promise<Province[]> {
      const { data } = await wrapApiCall(() => client.get<Record<string, unknown>[]>('/provinces'))
      return data?.map((item: Record<string, unknown>) => deserialize(item, Province)) || []
    },
    async getDistrictsByProvince(provinceId: number): Promise<District[]> {
      const { data } = await wrapApiCall(() =>
        client.get<Record<string, unknown>[]>(`/provinces/${provinceId}/districts`)
      )
      return data?.map((item: Record<string, unknown>) => deserialize(item, District)) || []
    },
    async getSubDistrictsByDistrict(districtId: number): Promise<SubDistrict[]> {
      const { data } = await wrapApiCall(() =>
        client.get<Record<string, unknown>[]>(`/districts/${districtId}/subdistricts`)
      )
      return data?.map((item: Record<string, unknown>) => deserialize(item, SubDistrict)) || []
    },
    async getRoleGroups(): Promise<RoleGroup[]> {
      const { data } = await wrapApiCall(() =>
        client.get<Record<string, unknown>[]>('/roles/groups')
      )
      return data?.map((item: Record<string, unknown>) => deserialize(item, RoleGroup)) || []
    },
    async getRoles(): Promise<Role[]> {
      const { data } = await wrapApiCall(() => client.get<Record<string, unknown>[]>('/roles'))
      return data?.map((item: Record<string, unknown>) => deserialize(item, Role)) || []
    },
    async getServices(): Promise<TrainingService[]> {
      const { data } = await wrapApiCall(() => client.get<Record<string, unknown>[]>('/services'))
      return data?.map((item: Record<string, unknown>) => deserialize(item, TrainingService)) || []
    },
  }
}
